// LLM generated - Model Claude 4 Sonnet
import { HeaderTitle } from '../components/HeaderTitle';
import { HeaderSubtitle } from '../components/HeaderSubtitle';
import { BrandBadges } from '../components/BrandBadges';
import { BRANDS } from '~/domains/auth/consts';
import type { titleStyles } from '~/domains/design-system/Title';

type RYPRendererProps = {
  title: string;
  brandText: string;
  titleVariant: keyof typeof titleStyles;
  isLogoVisible: boolean;
  classes: {
    LoginHeaderTitle: string;
    brandBadgesContainer: string;
  };
};

export function RYPRenderer({
  title,
  brandText,
  titleVariant,
  isLogoVisible,
  classes,
}: RYPRendererProps) {
  return (
    <>
      {isLogoVisible && <BrandBadges brand={BRANDS.RYP} className={classes.brandBadgesContainer} />}
      <HeaderTitle title={title} variant={titleVariant} className={classes.LoginHeaderTitle} />
      <HeaderSubtitle text={brandText} />
    </>
  );
}
